import PropTypes from 'prop-types';

import { useSoyuzExperiment } from '@spotahome/soyuz/client';
import classNames from 'classnames';

import styles from './MobileMenu.module.scss';

const MobileMenuLink = props => {
  const isHeaderRedesignVariant =
    useSoyuzExperiment('HeaderRedesign').get('behaviour') === 'variant';

  const classes = classNames(styles.link, {
    [styles['link--redesign']]: isHeaderRedesignVariant
  });

  return (
    <a {...props} className={classes}>
      {props.children}
    </a>
  );
};

MobileMenuLink.propTypes = {
  children: PropTypes.node.isRequired
};

export default MobileMenuLink;
